<template lang="html">
  <div class="contPrincipal" v-if="open">
    <div class="nuevaCont">
      <img src="../../assets/iconos/cerrarB.png" v-on:click="cerrar" alt="">
      <input type="text" placeholder="¿Cuál es la categoría?" />
      <button type="submit" v-on:click="cerrar">Guardar</button>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        open: this.$store.state.nuevaCategoria,
      };
    },
    components: {},
    methods: {
      cerrar: function () {

        var thisTemporal = this;

        thisTemporal.open = false;
        thisTemporal.$store.state.nuevaCategoria = false;
        console.log(thisTemporal.$store.state.nuevaCategoria);

      },
    },
    mounted: function () { },
  };
</script>

<style lang="css" scoped>
  .contPrincipal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .nuevaCont {
    width: 90%;
    height: 180px;
    background-color: #bad9d8;
    border-radius: 6px;
    box-shadow: 6px 3px 16px rgba(0, 0, 0, 0.16);

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .nuevaCont img {
    width: 15px;
    height: 15px;
    margin-bottom: 15px;
    cursor: pointer;
  }

  .nuevaCont input {
    width: 70%;
    height: 30px;
    border: none;
    border-bottom: 1px solid #fff;
    background: none;
    font-size: 4.5vw;
  }

  .nuevaCont button {
    width: 65%;
    height: 30px;
    background-color: #fff;
    border: none;
    border-radius: 10px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
    margin-top: 30px;
    cursor: pointer;
  }
@media screen and (min-width: 768px) and (max-width: 1023px) 
{
  .nuevaCont
  {
    width: 80%;
    height: auto;
    padding: 40px 0;
  }

  .nuevaCont img 
  {
    width: 20px;
    height: 20px;
    margin-bottom: 30px;
  }

  .nuevaCont input 
  {
    height: 50px;
    font-size: 1.2em;
  }

  .nuevaCont button
  {
    width: 60%;
    font-size: 1.2em;
    height: 40px;
  }
}

@media screen and (min-width: 1024px) 
{
  .contPrincipal
  {
    width: 95%;
    left: 5%;
  }

  .nuevaCont
  {
    width: 40%;
    height: auto;
    padding: 30px 0;
  }

  .nuevaCont img 
  {
    margin-bottom: 40px;
  }

  .nuevaCont input 
  {
    font-size: 0.8em;
  }

  .nuevaCont button 
  {
    width: 55%;
    font-size: 0.8em;
  }

}
</style>